import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import googleCalendarPlugin from '@fullcalendar/google-calendar';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid'; // 追加
import 'magnific-popup';  // インポート

document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('calendar')) {
    var calendarEl = document.getElementById('calendar');
    var calendar = new Calendar(calendarEl, {
      plugins: [
        dayGridPlugin,
        googleCalendarPlugin,
        listPlugin,
        timeGridPlugin
      ],
      initialView: 'listMonth',
      googleCalendarApiKey: 'AIzaSyDMuqwLZsILBOj7LLguA5ExUhgPGW_8Iis',
      locale: 'ja',
      contentHeight: 'auto',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,listMonth' // listWeek追加
      },
      buttonText: {
        month: '月',
        week: '週',
        day: '日',
        list: 'リスト'
      },
      eventSources: [
        {
          googleCalendarId: 'atleticosuzukaclub@gmail.com',
          className: 'team-event'
        },
        {
          googleCalendarId: 'japanese__ja@holiday.calendar.google.com',
          display: 'background',
          className: 'holiday-event'
        }
      ],
      eventSourceFailure: function(error) {
        console.error('Calendar error:', error);
      }
    });
    calendar.render();
  }
});

/* magnificPopup */
$(function() {
  if(document.getElementsByClassName('js-magnificPopup').length) {
    $('.js-magnificPopup').magnificPopup({
      type: 'inline',
      midClick: true,
      closeOnBgClick: true,
      closeBtnInside: false,
      closeBtnOnMobile: false,
    });
  }
});
